@if (showGuide$ | async) {
    @if (!isMobile) {
        @if (isCollapsedSidebarButton) {
            <button
                type="button"
                class="setup-guide-sidebar-collapsed flex align-items-center justify-content-center cursor-pointer p-0 border-none my-1 mx-auto border-round-lg"
                #desktopButtonRef
                (click)="openGuide($event)"
                title="Quick Start Guide">
                    <img 
                    class="block flex-shrink-0"
                    src="assets/img/tablet-menu-quick-start.svg" alt="Quick Start" />
            </button>
        } @else {
            <div
                class="setup-guide-expanded-card border-round p-3 relative cursor-pointer flex flex-column gap-2"
                (click)="openGuide($event)"
                #desktopButtonRef>
                <div class="flex justify-content-between align-items-start gap-2">
                    <span
                        class="font-bold text-base text-white flex-1 min-w-0 line-height-3 white-space-nowrap overflow-hidden text-overflow-ellipsis">
                        {{ guideTitle$ | async }}
                    </span>
                    <i class="pi pi-window-maximize text-white cursor-pointer flex-shrink-0"></i>
                </div>

                <div
                    class="flex align-items-center w-full gap-1"
                    role="progressbar"
                    [attr.aria-valuenow]="completedSteps"
                    [attr.aria-valuemin]="0"
                    [attr.aria-valuemax]="maxSteps">
                    @for (step of stepsArray; track step) {
                        <div
                            class="flex-1 border-round"
                            [style.height.px]="4"
                            [style.background]="
                                completedSteps >= step
                                    ? 'var(--check-icon-text-color)'
                                    : 'var(--surface-0)'
                            ">
                        </div>
                    }
                </div>
            </div>
        }
    } @else {
        <button
            type="button"
            class="quick-start-pill fixed flex align-items-center gap-2 text-white font-bold text-sm cursor-pointer py-2 px-3 border-round-xl line-height-1 border-none select-none"
            #mobileButtonRef
            (click)="openGuide($event)">
            <img 
            class="block flex-shrink-0"
            src="assets/img/tablet_menu_quick_start.webp" alt="" />
            <span>Quick Start</span>
        </button>
    }

    <app-onboarding-guide
        #onboardingGuide
        [steps]="(steps$ | async) ?? []"
        [asapFormId]="currentAsapFormId"
        (stepsChange)="onStepsChange($event)">
    </app-onboarding-guide>
}
